



























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({})
export default class orgImportTable extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  dataList;
  total = 0;
  pageSize = 10;
  currentPage = 1;
  // currentdata: any = [];
  layout = "total, prev, pager, next";
  tableList: any = [];
  isShowName: Boolean = true;
  @Watch("dataList", { immediate: true })
  watchDataList(list) {
    let isShowName = true;
    if (list.some(v => !v.storeName)) {
      isShowName = false;
    }
    this.isShowName = isShowName;
    this.currentPage = 1;
    this.init();
  }
  init() {
    this.tableList = this.pagination(
      this.dataList,
      this.pageSize,
      this.currentPage
    );
  }
  pagination(list, size, page) {
    return list.slice(size * (page - 1), size * (page - 1) + size);
  }
  handlePageChange(page) {
    this.currentPage = page;
    this.init();
  }
}
